interface ComputerWithMapAndLittleBoxSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithMapAndLittleBoxSVG = ({
  color,
  style,
}: ComputerWithMapAndLittleBoxSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="50"
    viewBox="0 0 46 50"
    fill="none"
  >
    <g clipPath="url(#clip0_678_13665)">
      <path
        d="M28.119 7.77512H2.64057C1.4628 7.77512 0.505859 8.73205 0.505859 9.90982V32.9959C0.505859 34.1737 1.4628 35.1307 2.64057 35.1307H35.2133C36.391 35.1307 37.348 34.1737 37.348 32.9959V19.9117"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3212 35.1215L29.9958 39.3541H18.9266H7.85742L9.53206 35.1215"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.8027 42.5653L35.6735 47.7457C36.1059 48.5278 35.5447 49.4847 34.6521 49.4847H3.21121C2.31868 49.4847 1.7574 48.5278 2.18986 47.7457L5.06068 42.5653H32.8119H32.8027Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.96 4.77549L37.3486 0.515274L44.7373 4.77549L37.3486 9.0449"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.7373 4.77548V13.3051L37.3486 17.5745L29.96 13.3051V4.77548"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.3486 9.04491V14.7129"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.15275 27.7604C9.92861 26.8955 11.548 28.3217 11.548 28.3217V13.2683C11.548 12.0997 10.6003 11.152 9.43173 11.152C8.26317 11.152 7.31543 12.0997 7.31543 13.2683V28.7081C7.31543 30.0515 8.40119 31.1465 9.75378 31.1465H30.5396V16.1943"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.4434 13.3511H27.9538"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_13665">
        <rect width="45.2429" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithMapAndLittleBoxSVG;
